<template>
  <v-card outlined class="pa-2" min-height="200px">
    <v-container>
      <v-row>
        <v-col>
          <page-render
            :widgets="widgets"
            :editOrShowTarget="editOrShowTarget"
            :paramId="paramId"
            :requestApiUrl="requestApiUrl"
            @on-pagination="onPagination"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>

import axios from "@axios";
import {
  formConfig,
  initialSidebarsSize,
  tableDateHandler,
  tablePaginationHandler
} from "@/views/generator/page-handler";
import {mdiClose} from "@mdi/js";

export default {
  name: "group",
  components: {PageRender: () => import('@/views/generator/page-render')},
  props: {
    // eslint-disable-next-line vue/require-default-prop
    state: Boolean,
    id: String,
    width: String,
    widgets: Array,
    title: String,
    editOrShowTarget: String,
    paramId: String,
    requestApiUrl: String,

  },
  data() {
    return {
      mdiClose: mdiClose,
      widthData: this.width,
      stateData: this.state,
      widgetsData: this.widgets, // Initial value
      titleData: this.title, // Initial value
      pagination: [],
      paginationToQueryString: "?",
      deleteUrl: "",
    }
  },
  watch: {
    state(newValue) {
      this.stateData = newValue // Update when the prop changes
    },
    nestedDialogId(newValue) {
      console.log("here value", newValue)
      this.nestedDialogIdData = newValue // Update when the prop changes
    },
    widgets(newValue) {
      this.widgetsData = newValue // Update when the prop changes
    },
    title(newValue) {
      this.titleData = newValue // Update when the prop changes
    }
  },
  mounted() {
    this.initing()
  },
  methods: {
    //dynamic ddl from request here
    initing() {
      this.widgetsData = formConfig(this.widgetsData)
      this.widgetsData = tableDateHandler(this.widgetsData)
    },
    onPagination(name, current,filter){
      this.$emit('on-pagination-nested', name, current, filter)
    }
  }
}
</script>

<style scoped>

</style>
